/* Desayunos del Cielo — "Los más pedidos" grid (sections/ddc-product-grid.liquid).
   Pure helpers are exported for node tests; init() wires every [data-ddc-grid] on the page. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', () => api.init(root));
    } else {
      api.init(root);
    }
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  const MOBILE_QUERY = '(max-width: 749px)';

  /* Price ranges in cents (Shopify prices). COP $100.000 = 10.000.000 cents. */
  const RANGES = {
    all: [0, Infinity],
    lt100: [0, 10000000],
    '100to150': [10000000, 15000000],
    gt150: [15000000, Infinity],
  };

  function priceOf(card) {
    if (card == null) return NaN;
    if (typeof card === 'number') return card;
    if (card.dataset && card.dataset.price != null) return Number(card.dataset.price);
    if (card.price != null) return Number(card.price);
    return NaN;
  }

  /* lt100: < 100.000 · 100to150: 100.000–150.000 (both inclusive) · gt150: > 150.000 */
  function inRange(cents, range) {
    const price = Number(cents);
    if (!range || range === 'all') return true;
    if (!Number.isFinite(price)) return false;
    switch (range) {
      case 'lt100': return price < RANGES.lt100[1];
      case '100to150': return price >= RANGES['100to150'][0] && price <= RANGES['100to150'][1];
      case 'gt150': return price > RANGES.gt150[0];
      default: return true;
    }
  }

  function filterByRange(cards, range) {
    return Array.from(cards || []).filter(card => inRange(priceOf(card), range));
  }

  /* How many of `total` matching cards are visible, and whether "Ver más" is needed. */
  function visibleCount(total, opts) {
    const { isMobile = false, expanded = false, desktop = 8, mobile = 6, max = 12 } = opts || {};
    const limit = isMobile ? (expanded ? max : mobile) : desktop;
    const shown = Math.min(total, limit);
    const showMore = isMobile && !expanded && total > mobile;
    return { shown, showMore };
  }

  function track(root, name, params) {
    if (typeof root.gtag === 'function') {
      root.gtag('event', name, params || {});
    } else {
      root.dataLayer = root.dataLayer || [];
      root.dataLayer.push(Object.assign({ event: name }, params || {}));
    }
  }

  function setupGrid(root, section) {
    if (section.__ddcGridReady) return;
    section.__ddcGridReady = true;

    const tabs = Array.from(section.querySelectorAll('[data-ddc-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-ddc-panel]'));
    const chips = Array.from(section.querySelectorAll('[data-ddc-range]'));
    const empty = section.querySelector('[data-ddc-empty]');
    const desktop = Number(section.dataset.cardsDesktop) || 8;
    const mobile = Number(section.dataset.cardsMobile) || 6;
    const mq = root.matchMedia ? root.matchMedia(MOBILE_QUERY) : null;
    const state = { tab: 0, range: 'all', expanded: new Set() };

    function render() {
      const panel = panels[state.tab];
      if (!panel) return;
      const cards = Array.from(panel.querySelectorAll('[data-ddc-card]'));
      const matches = filterByRange(cards, state.range);
      const { shown, showMore } = visibleCount(matches.length, {
        isMobile: mq ? mq.matches : false,
        expanded: state.expanded.has(state.tab),
        desktop,
        mobile,
      });
      const visible = new Set(matches.slice(0, shown));
      cards.forEach(card => { card.hidden = !visible.has(card); });

      const more = panel.querySelector('[data-ddc-more]');
      if (more) {
        more.hidden = !showMore;
        more.setAttribute('aria-expanded', String(state.expanded.has(state.tab)));
      }
      if (empty) empty.hidden = matches.length > 0;
    }

    function selectTab(index, focus) {
      if (index < 0 || index >= panels.length) return;
      state.tab = index;
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach((panel, i) => { panel.hidden = i !== index; });
      render();
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        if (state.tab === i) return;
        selectTab(i, false);
        track(root, 'home_grid_tab', { tab_label: tab.textContent.trim(), tab_index: i + 1 });
      });
      tab.addEventListener('keydown', event => {
        const last = tabs.length - 1;
        let next = null;
        if (event.key === 'ArrowRight') next = i === last ? 0 : i + 1;
        else if (event.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        selectTab(next, true);
        track(root, 'home_grid_tab', { tab_label: tabs[next].textContent.trim(), tab_index: next + 1 });
      });
    });

    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        state.range = chip.dataset.ddcRange || 'all';
        chips.forEach(c => c.setAttribute('aria-pressed', String(c === chip)));
        render();
      });
    });

    panels.forEach((panel, i) => {
      const more = panel.querySelector('[data-ddc-more]');
      if (!more) return;
      more.addEventListener('click', () => {
        state.expanded.add(i);
        render();
      });
    });

    section.addEventListener('click', event => {
      const link = event.target.closest && event.target.closest('[data-ddc-select-item]');
      if (!link) return;
      const panel = link.closest('[data-ddc-panel]');
      const listName = panel ? panel.dataset.listName : 'Los más pedidos';
      track(root, 'select_item', {
        item_list_name: listName,
        items: [{
          item_id: String(link.dataset.itemId || ''),
          item_name: link.dataset.itemName || link.textContent.trim(),
          price: Number(link.dataset.itemPrice) || 0,
          index: Number(link.dataset.itemIndex) || 0,
          item_list_name: listName,
        }],
      });
    });

    if (mq) {
      const onChange = () => render();
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }

    section.setAttribute('data-ready', '');
    selectTab(0, false);
  }

  /* "El más pedido del mes" (sections/ddc-product-spotlight.liquid): thumbnails swap the main image. */
  function setupSpotlight(section) {
    if (section.__ddcSpotReady) return;
    section.__ddcSpotReady = true;
    const main = section.querySelector('[data-ddc-spot-main]');
    const thumbs = Array.from(section.querySelectorAll('[data-ddc-spot-thumb]'));
    if (!main || !thumbs.length) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        main.src = thumb.dataset.src;
        if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset;
        main.alt = thumb.dataset.alt || main.alt;
        thumbs.forEach(t => t.setAttribute('aria-pressed', String(t === thumb)));
      });
    });
  }

  function init(root) {
    const doc = root.document;
    doc.querySelectorAll('[data-ddc-grid]').forEach(section => setupGrid(root, section));
    doc.querySelectorAll('[data-ddc-spotlight]').forEach(setupSpotlight);
    /* Theme editor: re-init a section after it is re-rendered. */
    if (!root.__ddcGridEditorBound) {
      root.__ddcGridEditorBound = true;
      doc.addEventListener('shopify:section:load', event => {
        if (!event.target.querySelectorAll) return;
        event.target.querySelectorAll('[data-ddc-grid]').forEach(section => setupGrid(root, section));
        event.target.querySelectorAll('[data-ddc-spotlight]').forEach(setupSpotlight);
      });
    }
  }

  return { RANGES, inRange, filterByRange, visibleCount, init };
});
